import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Page.css';

function Terms() {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="page-main">
        <div className="page-container">
          <div className="page-content">
            <Link to="/" className="back-link">← Назад</Link>
            <h1>Пользовательское соглашение</h1>
            <div className="page-text">
              <p>
                Настоящее Пользовательское соглашение регулирует отношения между Пользователем и Сервисом по использованию платформы для покупки Telegram Stars.
              </p>

              <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
              <p>
                1.1. Настоящий Договор является официальным предложением (публичной офертой) Исполнителя заключить договор на предоставление услуг на условиях, изложенных ниже.
              </p>
              <p>
                1.2. Акцептом оферты считается совершение Пользователем действий, направленных на использование Сервиса, включая внесение платежей. Акцепт означает полное и безоговорочное принятие всех условий Договора.
              </p>
              <p>
                1.3. Исполнитель вправе изменять условия оферты в одностороннем порядке. Новая редакция вступает в силу с момента её публикации. Использование Сервиса после изменений означает согласие с ними.
              </p>

              <h2>2. ПЕРЕЧЕНЬ УСЛУГ</h2>
              <p>
                2.1. Сервис предоставляет автоматизированные услуги:
              </p>
              <ul>
                <li>Продажа виртуальных активов «Telegram Stars»;</li>
                <li>Оформление подписки «Telegram Premium»;</li>
                <li>Приём платежей для приобретения «Telegram Stars».</li>
              </ul>
              <p>
                2.2. Услуги считаются оказанными с момента зачисления средств на счёт Пользователя в платформе Telegram.
              </p>

              <h2>3. СТОИМОСТЬ И ПОРЯДОК РАСЧЁТОВ</h2>
              <p>
                3.1. Оплата осуществляется через платёжные системы, интегрированные в Сервис.
              </p>
              <p>
                3.2. Услуги оказываются после полной предоплаты.
              </p>
              <p>
                3.3. Все транзакции являются окончательными. Возврат средств возможен только в случаях, предусмотренных разделом 5 Договора.
              </p>

              <h2>4. СРОКИ ОКАЗАНИЯ УСЛУГ</h2>
              <p>
                4.1. Стандартный срок зачисления средств — от 1 минуты до 24 часов.
              </p>
              <p>
                4.2. В периоды технических работ или повышенной нагрузки платформы Telegram возможны задержки.
              </p>

              <h2>5. ВОЗВРАТ СРЕДСТВ</h2>
              <p>
                5.1. Возврат осуществляется при:
              </p>
              <ul>
                <li>Неоказании услуги в течение 24 часов;</li>
                <li>Техническом сбое, подтверждённом Исполнителем.</li>
              </ul>
              <p>
                5.2. Возврат производится в эквиваленте оплаченной суммы в «Telegram Stars» на счёт Пользователя в течение 2 рабочих дней.
              </p>
              <p>
                5.3. Исполнитель не несёт ответственности за:
              </p>
              <ul>
                <li>Ошибки в реквизитах, указанных Пользователем;</li>
                <li>Использование неподдерживаемых кошельков;</li>
                <li>Действия третьих лиц;</li>
                <li>Сбои в работе блокчейн-сетей или платформы Telegram.</li>
              </ul>

              <h2>6. БЛОКИРОВКА СРЕДСТВ, АККАУНТА И УДЕРЖАНИЯ ВЫПЛАТ</h2>
              <p>
                6.1. Право блокировки и заморозки вывода средств
              </p>
              <p>
                Сервис вправе заблокировать аккаунт при выявлении фермы аккаунтов, подозрительной активности, манипуляций или нарушений условий обслуживания. В таких случаях применяется либо бессрочная блокировка, либо временная заморозка выплат сроком на 22 дня при продаже звёзд сервису.
              </p>
              <p>
                Если пользователь отказывается предоставить видео доказательства происхождения звёзд, сервис сохраняет заморозку выплат на 22 дня. Также возможен отказ в моментальной выплате, если на видео видно, что звёзды получены из сомнительных источников, включая Apple Pay и Google Pay.
              </p>
              <p>
                Кроме того, сервис может отказать в выводе средств без объяснения причин и наложить холд на аккаунт на 22 дня.
              </p>

              <h2>7. КРИТЕРИИ БЕССРОЧНОЙ БЛОКИРОВКИ</h2>
              <ul>
                <li>Систематические попытки обхода ограничений</li>
                <li>Действия, направленные на подрыв работы сервиса</li>
                <li>Многократные нарушения пользовательского соглашения</li>
                <li>Признаки мошенничества</li>
                <li>Рефаунды звёзд с целью мошенничества против сервиса</li>
              </ul>

              <h2>8. РЕКВИЗИТЫ И КОНТАКТЫ</h2>
              <p>
                Исполнитель: Telegram: @huesellerbot
              </p>
              <p>
                Поддержка: Обращения принимаются через аккаунт @ignatmalikov в течение 24 часов с момента возникновения спора.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Terms;

